/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BannerTranslationRequestDto } from './bannerTranslationRequestDto';

export interface BannerRequestDto {
  id: string;
  imageUrl: string;
  name: string;
  /**
   * 2021-10-01T00:00:00Z
   */
  startAt: string;
  /**
   * 2021-10-01T00:00:00Z
   */
  endAt: string;
  position: BannerRequestDto.PositionEnum;
  translations: Array<BannerTranslationRequestDto>;
}
// tslint:disable-next-line:no-namespace
export namespace BannerRequestDto {
  export type PositionEnum = 'tablet_wallpaper' | 'admin_wallpaper';
  export const PositionEnum = {
      TabletWallpaper: 'tablet_wallpaper' as PositionEnum,
      AdminWallpaper: 'admin_wallpaper' as PositionEnum,
  };
}
